import { SearchOptions, OpentionsNotFound } from "../../Translation";
import React, { useEffect, useState } from "react";

import { IconButton } from "@mui/material";
import { Mic } from "../../Icons";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import wordsToNumbers from "words-to-numbers";
import Fuse from "fuse.js";
import { AudioToTextApi } from "../../Api";
import useRecorder from "../ChatContent/recorder/useRecorder";

const btnStyle = {
  backgroundColor: "white",
  border: "1px solid #f5e6f5",
  borderRadius: "50%",
  padding: "5px",
  margin: "3px",
};
const btnStyle1 = {
  backgroundColor: "#91278f",
  border: "1px solid #f5e6f5",
  borderRadius: "50%",
  padding: "5px",
  margin: "3px",
};

function SchemesOptions(props: any) {
  const [dropdownStyle, setDropDownStyle] = useState("dropDown");
  const [searchField, SetsearchField] = useState(false);
  const [blinking, setBlinking] = useState("");
  const [blinkBckGround, setBlinkBckGround] = useState(btnStyle);
  const { transcript: transcriptSearch, listening, resetTranscript } = useSpeechRecognition();

  const {
    hideInput,
    selectedLanguage,
    optionList,
    setHideInput,
    setInputField,
    handleOptionClick,
    setBackOptions,
    optionHeader,
    searchTerm,
    setSearchTerm,
    recognitionSupported,
    pauseAudio,
    setRenderMic,
    renderMic,
    selectedServiceCategory,
    handleBackToServiceList,
    isPlaying,
  } = props;

  // Initialize useRecorder hook for audio capture (same approach as ChatContent)
  const recorder = useRecorder((audioDataUrl) => {
    console.log('🎬 [SchemesOptions] Recorder onBlob callback triggered');
    console.log('🎬 [SchemesOptions] Audio data URL length:', audioDataUrl?.toString().length);

    // Extract base64 from data URL (format: "data:audio/webm;base64,...")
    const base64Audio = audioDataUrl.toString().split(',')[1] || "";

    if (!base64Audio) {
      console.error("❌ [SchemesOptions] Failed to extract base64 from audio data URL");
      setRenderMic(true);
      setBlinking("");
      return;
    }

    console.log('🚀 [SchemesOptions] Calling AudioToTextApi with base64 audio');

    AudioToTextApi(base64Audio, selectedLanguage, (response: any) => {
      console.log("🎧 [SchemesOptions] AudioToTextApi response:", response);

      const textFromApi: string =
        (response &&
          (response.text ||
            response.transcription ||
            response.transcript)) ||
        "";

      console.log("📝 [SchemesOptions] Extracted text:", textFromApi);

      if (!textFromApi || !textFromApi.trim().length) {
        console.warn("⚠️ [SchemesOptions] AudioToTextApi returned empty text.");
        setRenderMic(true);
        setBlinking("");
        return;
      }

      const normalizedText = textFromApi.toLowerCase().trim();
      const queryToDisplay = textFromApi.trim();

      // If options exist, check if voice input matches an option
      if (optionList && optionList.length > 0) {
        const isServiceFormat = optionList[0].name !== undefined;
        const matchResult = findBestMatch(normalizedText, optionList, isServiceFormat);

        console.log("🔍 [SchemesOptions] Match result:", matchResult);

        if (matchResult && matchResult.item && matchResult.score !== undefined && matchResult.score < 0.6) {
          console.log("✅ [SchemesOptions] Good match found, auto-selecting option");
          setRenderMic(true);
          setBlinking("");
          handleOptionClick(matchResult.item, queryToDisplay);
          return;
        }
      }

      // No match: show as search term
      console.log("🔍 [SchemesOptions] No match found, showing as search term");
      setSearchTerm(normalizedText);
      setInputField(true);
      setRenderMic(true);
      setBlinking("");
    });
  });

  // Check if device is iOS/Mac
  const isIOSDevice = () => {
    const platform = window.navigator.platform.toLowerCase();
    return platform.includes("mac") || platform.startsWith("ip");
  };

  // Check if options are in service list format
  const isServiceListFormat = optionList && optionList.length > 0 && optionList[0].name !== undefined;

  const filteredStatesOptions =
    optionList &&
    optionList.length > 0 &&
    optionList.filter((val: any) => {
      if (isServiceListFormat) {
        const searchText = (val.name || val.en || "").toLowerCase();
        const searchTermLower = searchTerm.toLowerCase();
        const searchTextConverted = wordsToNumbers(searchText);
        const searchTermConverted = wordsToNumbers(searchTermLower);
        const searchTextStr = searchTextConverted !== null && searchTextConverted !== undefined
          ? searchTextConverted.toString()
          : searchText;
        const searchTermStr = searchTermConverted !== null && searchTermConverted !== undefined
          ? searchTermConverted.toString()
          : searchTermLower;
        return searchTextStr.includes(searchTermStr) || searchText.includes(searchTermLower);
      } else {
        const labelText = val.label.toLowerCase();
        const searchTermLower = searchTerm.toLowerCase();
        const labelTextConverted = wordsToNumbers(labelText);
        const searchTermConverted = wordsToNumbers(searchTermLower);
        const labelTextStr = labelTextConverted !== null && labelTextConverted !== undefined
          ? labelTextConverted.toString()
          : labelText;
        const searchTermStr = searchTermConverted !== null && searchTermConverted !== undefined
          ? searchTermConverted.toString()
          : searchTermLower;
        return labelTextStr.includes(searchTermStr) || labelText.includes(searchTermLower);
      }
    });

  const requestPermission = async () => {
    try {
      startRecognition();
    } catch (error) {
      console.error("Permission denied:", error);
      alert("Error: " + error);
    }
  };

  const startRecognition = async () => {
    console.log("🎤 ========== MIC CLICKED - START RECOGNITION (OPTIONS MIC) ==========");
    console.log("🎤 Current transcript before reset:", transcriptSearch);
    console.log("🎤 isIOSDevice:", isIOSDevice());
    console.log("🎤 navigator.mediaDevices:", !!navigator.mediaDevices, "(required for mic in WebView)");
    console.log("🎤 About to request mic access. If you see permission denied later, check Flutter/native app mic permission.");

    setSearchTerm("");

    // Reset transcript
    resetTranscript();
    hasTranscriptRef.current = false;

    setRenderMic(false);
    pauseAudio();

    // Force-abort any lingering SpeechRecognition session before starting new one
    try {
      SpeechRecognition.abortListening();
      console.log("🧹 [SchemesOptions] Aborted any previous SpeechRecognition session");
    } catch (err) {
      console.warn("⚠️ [SchemesOptions] Error aborting previous session:", err);
    }

    // iOS Safari only supports en-US for Web Speech API
    const speechRecLang = isIOSDevice() ? `en-US` : `${selectedLanguage}-IN`;
    SpeechRecognition.startListening({
      continuous: false,
      language: speechRecLang,
    });

    // Start audio recording using useRecorder hook
    try {
      // iOS delay to ensure previous mic resources are released
      if (isIOSDevice()) {
        console.log("🍎 [SchemesOptions] iOS detected - waiting 500ms before accessing mic");
        await new Promise(resolve => setTimeout(resolve, 500));
        console.log("🍎 [SchemesOptions] 500ms delay complete");
      }

      console.log("🎙️ [SchemesOptions] Calling recorder.startRecording()...");
      console.log("🎙️ [SchemesOptions] Requesting mic access (getUserMedia) - check logs for 'MIC PERMISSION GRANTED' or 'FAILED'");
      optionsRecordingStartedRef.current = true; // Mark that WE started recording
      recorder.startRecording();
      console.log("✅ [SchemesOptions] recorder.startRecording() called");

      // iOS-specific: Auto-stop after 5 seconds since Speech Recognition may not reliably stop
      if (isIOSDevice()) {
        console.log("🍎 [SchemesOptions] iOS: Setting 5-second auto-stop timer");
        const autoStopTimer = setTimeout(() => {
          if (listening) {
            console.log("⏰ [SchemesOptions] iOS auto-stop timer fired - forcing stop");
            stopRecognition();
          }
        }, 5000);

        // Store timer ref for cleanup
        (window as any).__schemesOptionsAutoStopTimer = autoStopTimer;
      }
    } catch (err: any) {
      optionsRecordingStartedRef.current = false;
      console.error("❌ [SchemesOptions] Error starting recording:", err);
      setBlinking("");
      setBlinkBckGround(btnStyle);
      setRenderMic(true);
    }

    setBlinking("blink");
    setBlinkBckGround(btnStyle1);
    console.log("🎤 ========== MIC SETUP COMPLETE ==========");
  };

  const handleMicClick = () => {
    if (listening) {
      console.log("🎤 [SchemesOptions] Mic active - stopping recognition (user tapped to stop)");
      stopRecognition();
      return;
    }

    if (recognitionSupported) {
      startRecognition();
    } else {
      requestPermission();
    }
  };

  const stopRecognition = () => {
    console.log("🛑 [SchemesOptions] stopRecognition called");

    // Clear iOS auto-stop timer if it exists
    if ((window as any).__schemesOptionsAutoStopTimer) {
      console.log("🧹 [SchemesOptions] Clearing iOS auto-stop timer");
      clearTimeout((window as any).__schemesOptionsAutoStopTimer);
      (window as any).__schemesOptionsAutoStopTimer = null;
    }

    // Stop browser SpeechRecognition
    SpeechRecognition.stopListening();

    // Reset transcript
    try {
      resetTranscript();
      hasTranscriptRef.current = false;
    } catch (err) {
      console.error("❌ [SchemesOptions] Error resetting transcript:", err);
    }

    // Note: Do NOT reset optionsRecordingStartedRef here - the listening effect needs it
    // to determine whether to call saveRecording(). The effect will reset it after saving.

    // Visual reset
    setBlinking("");
    setBlinkBckGround(btnStyle);

    console.log("✅ [SchemesOptions] stopRecognition complete");
  };

  React.useEffect(() => {
    if (optionList && optionList.length < 5) {
      setDropDownStyle("dropDown_");
    } else {
      setDropDownStyle("dropDown");
    }

    if (optionList && optionList.length > 0) {
      SetsearchField(true);
    } else {
      SetsearchField(false);
    }
    setSearchTerm("");
    setBlinking("");
  }, [optionList]);

  // Track previous isPlaying state
  const prevIsPlayingRef = React.useRef<boolean | null>(null);

  React.useEffect(() => {
    const wasPlaying = prevIsPlayingRef.current === true;
    const audioJustEnded = wasPlaying && !isPlaying;
    prevIsPlayingRef.current = isPlaying;

    if (hideInput && audioJustEnded && optionList && optionList.length > 0) {
      // Skip auto-open for iOS - MediaRecorder fails to capture when auto-opened
      // iOS users will manually click the mic button instead
      if (isIOSDevice()) {
        console.log("🍎 [SchemesOptions] iOS detected - skipping auto-open, user must click mic manually");
        return;
      }

      // For non-iOS devices, auto-open mic after short delay
      const delay = 200;
      console.log(`⏰ [SchemesOptions] Audio ended, auto-opening mic in ${delay}ms`);

      const timer = setTimeout(() => {
        console.log(`🎤 [SchemesOptions] Auto-opening mic after ${delay}ms delay`);
        if (recognitionSupported) {
          startRecognition();
        } else {
          requestPermission();
        }
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [hideInput, isPlaying]);

  const hasStartedListening = React.useRef(false);
  const hasTranscriptRef = React.useRef(false);
  // CRITICAL: Only call saveRecording when WE (options mic) started the recording.
  // "listening" is shared with ChatContent - when main mic stops, listening goes false
  // and this effect would run and incorrectly call saveRecording() with null recorder.
  const optionsRecordingStartedRef = React.useRef(false);

  // Cleanup effect
  React.useEffect(() => {
    return () => {
      console.log("🧹 [SchemesOptions] Component unmounting");
      try {
        SpeechRecognition.stopListening();
      } catch (err) {
        console.error("❌ [SchemesOptions] Error stopping SpeechRecognition on unmount:", err);
      }
      // useRecorder handles its own cleanup
    };
  }, []);

  // Listening state effect
  React.useEffect(() => {
    console.log("👂 ========== LISTENING STATE CHANGED ==========");
    console.log("👂 listening:", listening);
    console.log("👂 blinking:", blinking);

    if (listening) {
      hasStartedListening.current = true;
      hasTranscriptRef.current = false;
      console.log("✅ Listening STARTED");

      const noTranscriptTimer = setTimeout(() => {
        if (listening && !hasTranscriptRef.current) {
          console.log("⚠️ [SchemesOptions] Mic is ACTIVE but no transcript captured yet");
        }
      }, 2000);

      return () => clearTimeout(noTranscriptTimer);
    }

    // Listening stopped
    if (!listening && hasStartedListening.current) {
      console.log("🛑 ========== LISTENING STOPPED ==========");
      setBlinking("");
      setBlinkBckGround(btnStyle);
      hasStartedListening.current = false;

      // Only save if WE (options mic) started the recording - not when main mic stopped!
      // "listening" is shared with ChatContent, so when user stops main mic we get here too
      // but our recorder was never started in that case.
      if (optionsRecordingStartedRef.current) {
        console.log("🛑 [SchemesOptions] Options mic was recording - will call recorder.saveRecording()...");
        optionsRecordingStartedRef.current = false;
        // Defer so we run after React state updates (e.g. from ChatContent transcript effect)
        // so our useRecorder ref is still the active recorder when handler runs
        const saveFn = recorder.saveRecording.bind(recorder);
        setTimeout(() => {
          console.log("🛑 [SchemesOptions] (deferred) Calling recorder.saveRecording() now");
          saveFn();
          console.log("✅ [SchemesOptions] recorder.saveRecording() called");
        }, 0);
      } else {
        console.log("🛑 [SchemesOptions] Main mic stopped (not options mic) - skipping saveRecording");
      }

      console.log("🛑 ========== LISTENING CLEANUP COMPLETE ==========");
    } else if (!listening && blinking === "blink" && !hasStartedListening.current) {
      const safetyTimer = setTimeout(() => {
        if (blinking === "blink" && !listening) {
          console.log("⚠️ Safety timeout - resetting animation");
          setBlinking("");
          setBlinkBckGround(btnStyle);
        }
      }, 2000);
      return () => clearTimeout(safetyTimer);
    }
  }, [listening, blinking]);

  // Helper function to normalize text
  const normalizeText = (text: string): string => {
    const commonWords = ['a', 'an', 'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by'];
    return text
      .toLowerCase()
      .split(/\s+/)
      .filter(word => word.length > 0 && !commonWords.includes(word))
      .join(' ')
      .trim();
  };

  // Helper function to find best match
  const findBestMatch = (transcript: string, options: any[], isServiceFormat: boolean) => {
    const transcriptLower = transcript.toLowerCase().trim();
    const transcriptNormalized = normalizeText(transcriptLower);

    const optionsForFuse = options.map((val: any) => {
      const displayText = isServiceFormat
        ? (val.name || val.en || "").toLowerCase()
        : val.label.toLowerCase();
      const normalizedText = normalizeText(displayText);
      return {
        ...val,
        searchText: displayText,
        normalizedText: normalizedText,
        originalText: displayText
      };
    });

    // Try exact substring match
    const exactMatch = optionsForFuse.find((opt: any) =>
      opt.searchText.includes(transcriptLower) || transcriptLower.includes(opt.searchText)
    );
    if (exactMatch) {
      return { item: exactMatch, score: 0 };
    }

    // Try normalized text match
    const normalizedMatch = optionsForFuse.find((opt: any) =>
      opt.normalizedText.includes(transcriptNormalized) ||
      transcriptNormalized.includes(opt.normalizedText) ||
      opt.normalizedText === transcriptNormalized
    );
    if (normalizedMatch) {
      return { item: normalizedMatch, score: 0.1 };
    }

    // Use Fuse.js for fuzzy matching
    const fuseOptions = {
      keys: ['searchText', 'normalizedText'],
      threshold: 0.6,
      includeScore: true,
      minMatchCharLength: 2,
      ignoreLocation: true,
      findAllMatches: false
    };

    const fuse = new Fuse(optionsForFuse, fuseOptions);
    const results = fuse.search(transcriptLower);

    if (results.length === 0 || (results[0].score && results[0].score > 0.5)) {
      const normalizedResults = fuse.search(transcriptNormalized);
      if (normalizedResults.length > 0 && normalizedResults[0].score !== undefined) {
        return normalizedResults[0];
      }
    }

    return results.length > 0 ? results[0] : null;
  };

  // Transcript effect - we now use useRecorder callback instead
  React.useEffect(() => {
    // useRecorder handles transcript via AudioToTextApi callback
    return;
  }, [transcriptSearch, optionList, renderMic]);

  return (
    <React.Fragment>
      {hideInput && (
        <div className={dropdownStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            {selectedServiceCategory && handleBackToServiceList ? (
              <span
                onClick={() => {
                  if (listening || !renderMic) {
                    SpeechRecognition.stopListening();
                  }
                  optionsRecordingStartedRef.current = false;
                  setBlinking("");
                  setBlinkBckGround(btnStyle);
                  setRenderMic(true);
                  setSearchTerm("");
                  handleBackToServiceList();
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000000",
                  fontWeight: "500",
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center"
                }}
                title="Back to services"
              >
                ← Back
              </span>
            ) : <div></div>}
            <div className="closeIcon">
              <img
                src="close.png"
                width={15}
                height={15}
                alt="close"
                className="close"
                onClick={() => {
                  if (listening || !renderMic) {
                    SpeechRecognition.stopListening();
                  }
                  optionsRecordingStartedRef.current = false;
                  setBlinking("");
                  setBlinkBckGround(btnStyle);
                  setRenderMic(true);
                  setSearchTerm("");
                  setHideInput(false);
                  setInputField(false);
                  setBackOptions(true);
                  if (handleBackToServiceList && selectedServiceCategory) {
                    handleBackToServiceList();
                  }
                }}
              />
            </div>
          </div>
          <span className="optionHeader">
            {selectedServiceCategory
              ? (selectedServiceCategory.name || selectedServiceCategory.en || optionHeader)
              : optionHeader}
          </span>
          {searchField && (
            <div className="BoxSentMSGSchemes">
              <>
                <input
                  className="inputSchemes"
                  type="text"
                  placeholder={(SearchOptions as any)[selectedLanguage]}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <IconButton
                  size="small"
                  style={blinkBckGround}
                  className={blinking ? "micBtnActive" : ""}
                  onClick={handleMicClick}
                >
                  <span className={blinking}> {Mic}</span>
                </IconButton>
              </>
            </div>
          )}

          <div style={{ overflowY: "scroll", height: "100%" }}>
            {filteredStatesOptions && filteredStatesOptions.length > 0 ? (
              filteredStatesOptions.map((val: any, index: number) => {
                const displayText = isServiceListFormat
                  ? (val.name || val.en || "")
                  : val.label;

                const elementId = isServiceListFormat
                  ? (val.id || val.name || "")
                  : (val.value || "");

                return (
                  <div
                    className="optionContainer"
                    key={index}
                    style={isServiceListFormat && val.iconUrl ? { display: "flex", alignItems: "center" } : {}}
                  >
                    {isServiceListFormat && val.iconUrl && (
                      <img
                        src={val.iconUrl}
                        alt={displayText}
                        style={{ width: "24px", height: "24px", marginRight: "8px", flexShrink: 0 }}
                      />
                    )}
                    <p
                      className="optionItem"
                      id={elementId}
                      onClick={() => handleOptionClick(val)}
                      style={{ margin: 0, flex: 1 }}
                    >
                      {displayText.toUpperCase()}
                    </p>
                  </div>
                );
              })
            ) : (
              <span>
                <div className="optionContainer">
                  <p className="optionItem">
                    {(OpentionsNotFound as any)[selectedLanguage]}
                  </p>
                </div>
              </span>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default SchemesOptions;
